import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { H6Emphasized, YStack } from 'smoothie';

import type { DbosCronItem } from '../types/DbosTypes';
import { formatIsoTimestamp, timeAgo } from './dbosConstants';

interface DbosCronStatusProps {
    crons: DbosCronItem[];
}

export const DbosCronStatus = ({ crons }: DbosCronStatusProps) => {
    const rowClassName = (rowData: DbosCronItem) => {
        if (rowData.lastRunTime == null) return 'cron-never-run';
        const ageMs = Date.now() - new Date(rowData.lastRunTime).getTime();
        const twoHoursMs = 2 * 60 * 60 * 1000;
        if (ageMs > twoHoursMs) return 'cron-stale';
        return '';
    };

    return (
        <YStack gap={8} width="100%">
            <H6Emphasized>Scheduled Cron Jobs</H6Emphasized>
            <DataTable
                value={crons}
                size="small"
                tableStyle={{ width: '100%', fontSize: '0.875rem' }}
                emptyMessage="No cron jobs found"
                rowClassName={rowClassName}
            >
                <Column
                    field="workflowFnName"
                    header="Function"
                    style={{ fontSize: '0.75rem' }}
                    body={(row: DbosCronItem) => (
                        <span
                            style={{
                                fontSize: '0.75rem',
                                fontFamily: 'monospace',
                            }}
                        >
                            {row.workflowFnName}
                        </span>
                    )}
                />
                <Column
                    header="Last Run"
                    style={{ fontSize: '0.75rem' }}
                    body={(row: DbosCronItem) => (
                        <span style={{ fontSize: '0.75rem' }}>
                            {formatIsoTimestamp(row.lastRunTime)}
                        </span>
                    )}
                />
                <Column
                    header="Age"
                    style={{ fontSize: '0.75rem' }}
                    body={(row: DbosCronItem) => {
                        const age = timeAgo(row.lastRunTime);
                        const isStale =
                            row.lastRunTime == null ||
                            Date.now() - new Date(row.lastRunTime).getTime() >
                                2 * 60 * 60 * 1000;
                        return (
                            <span
                                style={{
                                    fontSize: '0.75rem',
                                    color: isStale ? '#e65100' : '#28a745',
                                    fontWeight: isStale ? 'bold' : 'normal',
                                }}
                            >
                                {age}
                            </span>
                        );
                    }}
                />
            </DataTable>

            <style>{`
                .p-datatable .cron-stale {
                    background-color: #fff3e0 !important;
                }
                .p-datatable .cron-never-run {
                    background-color: #ffebee !important;
                }
            `}</style>
        </YStack>
    );
};
